/**
 * Hook to check if a driver can be removed from the notification list
 * Logic:
 * - If combined active assigned + unassigned drivers are atleast 2 then it can be removed
 * - Else it can't be removed as we need atleas one entry to send notification
 * @param drivers
 * @param payload
 * @param otherTypeDrivers
 * @param otherTypePayload
 * @returns
 */

import { INotifyDriverWithFullSegment } from '../TwNotifyDriver';
import { OrderSharePreviewParams } from '../../../redux/api/orders/orders.model';
import { useMemo } from 'react';

const useCanRemoveDrivers = (
  assignedDrivers: INotifyDriverWithFullSegment[],
  assignedPayload: OrderSharePreviewParams[],
  unassignedDrivers: INotifyDriverWithFullSegment[],
  unassignedPayload: OrderSharePreviewParams[]
): boolean => {
  return useMemo(() => {
    const activeAssignedDrivers = assignedDrivers.filter((driver) => {
      const payloadItem = assignedPayload.find(
        (p) => p.driver_id === driver.driverId && p.trip_id === driver.fullSegment.id
      );
      return !driver.removed && !!payloadItem;
    }).length;

    const activeUnassignedDrivers = unassignedDrivers.filter((driver) => {
      const payloadItem = unassignedPayload.find(
        (p) => p.driver_id === driver.driverId && p.trip_id === driver.fullSegment.id
      );
      return !driver.removed && !!payloadItem;
    }).length;

    return activeAssignedDrivers + activeUnassignedDrivers >= 2;
  }, [assignedDrivers, assignedPayload, unassignedDrivers, unassignedPayload]);
};

export default useCanRemoveDrivers;
